import { noop } from 'lodash'
import React from 'react'

import Sort from '../../Sort'
import { ColumnInfinityProps, TCheckboxValue, TSort } from '../../types'
import CheckboxColumn from '../CheckboxColumn'

interface HeaderRenderedProps
  extends Pick<
    ColumnInfinityProps,
    | 'toggleAllState'
    | 'toggleAll'
    | 'direction'
    | 'applyFilter'
    | 'setSort'
    | 'sortableColumns'
    | 'applyLocalSort'
    | 'useLocalStateFiltering'
    | 'ui'
    | 'setCurrentRow'
  > {
  label: React.ReactNode
  disableSort: boolean
  isCheckColumn: boolean
  sorts: TSort | TSort[]
  sortKey: string
}

const HeaderRendered = (props: HeaderRenderedProps): React.ReactElement => {
  const {
    label,
    disableSort,
    isCheckColumn,
    toggleAllState,
    toggleAll = noop,
    direction,
    sorts,
    sortKey,
    applyFilter,
    setSort,
    sortableColumns,
    applyLocalSort,
    useLocalStateFiltering,
    ui,
    setCurrentRow,
  } = props

  if (isCheckColumn) {
    return (
      <CheckboxColumn
        {...props}
        onChange={() => toggleAll(toggleAllState !== true)}
        value={toggleAllState as TCheckboxValue}
        tooltip={
          toggleAllState !== true
            ? i18n.t(`toggle_all_inf`, `Alle auswählen`)
            : i18n.t(`untoggle_all_inf`, `Alle abwählen`)
        }
      />
    )
  }
  return (
    <Sort
      label={label}
      disableSort={disableSort}
      direction={direction}
      sorts={sorts}
      sortKey={sortKey}
      applyFilter={applyFilter}
      setSort={setSort}
      sortableColumns={sortableColumns}
      applyLocalSort={applyLocalSort}
      useLocalStateFiltering={useLocalStateFiltering}
      ui={ui}
      setCurrentRow={setCurrentRow}
    />
  )
}

export default HeaderRendered
